import { createFileRoute } from '@tanstack/react-router';
import { CustomerDetailPage } from '@/features/customers/customer-detail-page.js';

export const Route = createFileRoute('/_app/customers/$id')({
  component: CustomerDetailPage,
});
